var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 36,
    height: 36
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 2,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 1.25H5C2.92969 1.25 1.25 2.92969 1.25 5V13.75H38.75V5C38.75 2.92969 37.0703 1.25 35 1.25Z",
    fill: "#A4C2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.75 13.75H1.25V26.25H38.75V13.75Z",
    fill: "#B8CFE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 35C1.25 37.0703 2.92969 38.75 5 38.75H35C37.0703 38.75 38.75 37.0703 38.75 35V26.25H1.25V35Z",
    fill: "#CCDDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7276 23.7892V19.1547C19.2974 19.0795 20.5101 18.7411 21.3561 18.1489C22.2022 17.5567 22.6252 16.673 22.6252 15.5074V15.1031C22.6252 14.2101 22.3526 13.5145 21.8074 13.0162C21.2621 12.518 20.5383 12.2736 19.6171 12.2736C18.6488 12.2736 17.8686 12.5556 17.2857 13.1196C16.7029 13.6837 16.3081 14.3981 16.0919 15.2724L13.3281 14.1725C13.5067 13.5709 13.7605 12.988 14.099 12.424C14.4374 11.86 14.8698 11.3618 15.3962 10.9199C15.9227 10.4781 16.5431 10.1303 17.2575 9.86708C17.972 9.60387 18.7992 9.47226 19.7299 9.47226C20.6793 9.47226 21.5442 9.60387 22.3244 9.87648C23.1046 10.1491 23.7627 10.5345 24.3079 11.0233C24.8531 11.5216 25.2667 12.1232 25.5582 12.8282C25.8496 13.5333 26 14.3229 26 15.1783C26 16.0526 25.8496 16.8328 25.5488 17.5285C25.2479 18.2147 24.8531 18.8069 24.3549 19.2958C23.8567 19.7846 23.302 20.1794 22.6816 20.4802C22.0612 20.781 21.4219 20.9878 20.7545 21.11V23.7892H17.7276ZM19.2692 30.5199C18.5266 30.5199 17.9908 30.3413 17.6523 29.9841C17.3139 29.6269 17.1447 29.1663 17.1447 28.6022V28.104C17.1447 27.54 17.3139 27.0794 17.6523 26.7221C17.9908 26.3649 18.5266 26.1863 19.2692 26.1863C20.0119 26.1863 20.5477 26.3649 20.8861 26.7221C21.2245 27.0794 21.3937 27.54 21.3937 28.104V28.6022C21.3937 29.1663 21.2245 29.6269 20.8861 29.9841C20.5477 30.3413 20.0119 30.5199 19.2692 30.5199Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/default.041d45323a502f09ad730b6924e9353c.svg";
export { ForwardRef as ReactComponent };